import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ConstantSelector } from '../constant-selector.component';

@Component({
    selector: 'ca-icon-select',
    templateUrl: './icon-select.component.html',
    styleUrls: ['./icon-select.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => IconSelectComponent), multi: true }
    ],
    standalone: false
})
export class IconSelectComponent extends ConstantSelector {
  protected _defaultOptions = [
    'ca-accessibility',
    'ca-face',
    'ca-person-stalker',
    'ca-home',
    'ca-wc',
    'ca-restaurant_menu',
    'ca-work',
    'ca-content_paste',
    'ca-priority-severe',
    'ca-timer',
    'ca-thumbs-up',
    'ca-thumbs-down',
    'ca-nature_people',
    'ca-bath',
    'ca-shield',
    'ca-file-text-o',
    'ca-medkit',
    'ca-school',
    'ca-local_florist',
    'ca-local_taxi',
    'ca-healing',
    'ca-airport_shuttle'
  ];

  @Input() disabled = false;
  @Input() placeholder;
  @Input() options: string[] = this._defaultOptions;
}
